module.exports = __webpack_public_path__ + "img/logoutBg.66d40bb1.png";